import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Sites from './pages/Sites';
import SiteDetail from './pages/SiteDetail';
import SiteWidgets from './pages/SiteWidgets';
import WidgetEditor from './pages/WidgetEditor';

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/sites/:siteId" element={<SiteDetail />} />
        <Route path="/sites/:siteId/widgets" element={<SiteWidgets />} />
        <Route path="/sites/:siteId/widgets/:widgetId" element={<WidgetEditor />} />
      </Routes>
    </Layout>
  );
}
